import { getRowItemsFromSectionItem } from "@superblocksteam/shared";
import dot from "utils/dot";
import type {
  ActionConfigurationDto,
  ApiDto,
} from "../../../store/slices/apis";
import type { Plugin } from "@superblocksteam/shared";

export const getNormalizedName = (
  name: string,
  allowSpaces?: boolean,
): string => {
  if (name.length === 0) {
    return name;
  }

  const replacementChar = "_";
  name = name.match(/^[A-Za-z_]/g) ? name : `${replacementChar}${name}`;
  if (!allowSpaces) {
    name = name.replace(/\s+/g, replacementChar);
  }
  const regexWithSpaces = /[^A-Za-z0-9_ ]/g;
  const regexWithoutSpaces = /[^A-Za-z0-9_]/g;
  return name.replace(
    allowSpaces ? regexWithSpaces : regexWithoutSpaces,
    replacementChar,
  );
};

export const getInitialApiConfiguration = (
  plugin: { actionTemplate: Plugin["actionTemplate"] } | undefined,
): Partial<ActionConfigurationDto> => {
  const result: Partial<ActionConfigurationDto> = {};
  if (plugin) {
    plugin.actionTemplate.sections.forEach((section) => {
      section.items.forEach((sectionItem) => {
        const rowItems = getRowItemsFromSectionItem(sectionItem);
        for (const item of rowItems) {
          if (item.initialValue) {
            dot.copy("initialValue", item.name, item, result);
          }
        }
      });
    });
  }
  return result;
};

export const getApiExecutionParams = (api: ApiDto) => {
  const params = [];
  if (api?.actions?.workflowParams) {
    params.push(...api.actions.workflowParams);
  }
  if (api?.actions?.workflowQueries) {
    params.push(...api.actions.workflowQueries);
  }
  return params;
};
